import React, { lazy, Suspense, useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  Navbar,
  Nav,
  Container,
  Form,
  Button,
  Alert,
  Spinner,
  Card,
  FloatingLabel,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import {
  getbranchData,
  getMenuData,
  handleLogin,
} from "../../redux/authentication";
import { useDispatch, useSelector } from "react-redux";
import { getCourseData } from "../../redux/institute";
import useUserLocation from "./useUserLocation";
import { isWithinRange } from "./locationUtils";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const OtpModal = lazy(() => import("./OTPModal"));

const Login = ({ setUserRights }) => {
  const brandNavy = "#344e66"; // Paupetsoft Brand Navy Theme
  const { latitude, longitude } = useUserLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.authentication);
  const { userData, branchData } = auth;
  const { branch } = userData || {};

  const [selectedLaunch, setSelectedLaunch] = useState("default");
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);

  const [formData, setFormData] = useState({
    branch: branch || "",
    username: "",
    password: "",
  });

  const [otpDetails, setOTPDetails] = useState("");
  const [alert, setAlert] = useState({
    visible: false,
    message: "",
    color: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (formData.branch) {
      dispatch(getbranchData({ branch: formData.branch }));
    }
  }, [formData.branch, dispatch]);

  const passedAuthenticationHandler = (x) => {
    let data = x?.token ? x : otpDetails;
    setUserRights(otpDetails.rights);

    if (data.token) {
      dispatch(handleLogin({ ...data, branch: formData.branch }));
      dispatch(getbranchData({ branch: formData.branch, token: data.token }));
      dispatch(
        getMenuData({
          branch: formData.branch,
          role: data.rights,
          token: data.token,
        })
      );

      setAlert({
        visible: true,
        message: data.message || "Login successful!",
        color: "success",
      });

      if (selectedLaunch === "Admission") return navigate("/admission_form");
      if (selectedLaunch === "Attendance") return navigate("/student_attendance");
      if (selectedLaunch === "Feedback") return navigate("/feedback");
      if (selectedLaunch === "Hostel") return navigate("/hostel_management");
     if (branchData.businessType === "HOTEL_SERVICE_APARTMENTS") return navigate("/rooms_home");
     if (branchData.businessType) return navigate("/home");
    } else {
      setAlert({
        visible: true,
        message: data.message || "Invalid credentials!",
        color: "danger",
      });
    }
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleOtpSubmit = (otp) => {
    fetch(`${process.env.REACT_APP_COLLEGE_ERP_API}verify-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${otpDetails.token}`,
      },
      body: JSON.stringify({
        token: otpDetails.otpDetails.token,
        otp: otp.trim(),
        branch: otpDetails.branch,
        id: otpDetails.userId,
      }),
    })
      .then((r) => r.json())
      .then((res) => {
        if (res?.data?.message === "Verified") passedAuthenticationHandler(res);
      })
      .catch(console.error);
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (
      !branchData?.coordinates ||
      !Array.isArray(branchData?.coordinates.coordinates)
    )
      return;

    const withinAllowedRange = isWithinRange(
      branchData.coordinates.coordinates[0],
      branchData.coordinates.coordinates[1],
      latitude,
      longitude,
      0.8
    );

    const { branch, username, password } = formData;

  //  if (
  //    !withinAllowedRange &&
  //    ![
  //      "Siby",
  //      "Admin",
  //      "Sanoj",
  //      "Sam",
  //      "Renjusha",
  //      "Attendance",
  //      "Hostel",
  //      "Admission",
  //      "Sherin",
  //      "SuperAdmin",
  //    ].includes(username) &&
  //    branch !== "SSD" && branch !== "Demo"
  //  ) {
  //    window.alert("Unauthorized Location");
  //    return;
  //  }

    if (!branch || !username || !password) {
      setAlert({
        visible: true,
        message: "All fields are required!",
        color: "danger",
      });
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_COLLEGE_ERP_API}auth`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );

      const data = response.data;
      setOTPDetails(data);

      if (data.otpSent) return toggleModal();
      return passedAuthenticationHandler(data);
    } catch {
      setAlert({
        visible: true,
        message: "Login failed. Try again.",
        color: "danger",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ background: "#f8f9fa", minHeight: "100vh" }}>
      {/* 1. Header */}
     

      {/* 2. Main Login Form Card */}
      <Container className="d-flex align-items-center justify-content-center py-5" style={{ minHeight: "80vh" }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          style={{ width: "100%", maxWidth: "420px" }}
        >
          <Card className="border-0 shadow-lg px-2 py-3" style={{ borderRadius: "24px" }}>
            <Card.Header className="bg-white border-0 pt-4 pb-2 text-center">
              <img
                src="https://paupet-pub.s3.eu-north-1.amazonaws.com/logo512.png"
                alt="Logo"
                style={{ width: "55px", marginBottom: "12px" }}
              />
              <h4 className="fw-bold mb-1" style={{ color: brandNavy }}>
                Gatekeeper
              </h4>
              <p className="text-muted small mb-0">Paupetsoft Secure Portal</p>
            </Card.Header>

            <Card.Body className="px-4 pb-4">
              {alert.visible && (
                <Alert
                  variant={alert.color}
                  className="small py-2 text-center mb-3"
                  onClose={() => setAlert({ ...alert, visible: false })}
                  dismissible
                >
                  {alert.message}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                {/* Branch Input */}
                <FloatingLabel controlId="floatingBranch" label="Branch" className="mb-3">
                  <Form.Control
                    type="text"
                    name="branch"
                    placeholder="Branch"
                    value={formData.branch || ""}
                    onChange={handleChange}
                    className="bg-light border-0"
                    required
                  />
                </FloatingLabel>

                {/* Username Input */}
                <FloatingLabel controlId="floatingUsername" label="Username" className="mb-3">
                  <Form.Control
                    type="text"
                    name="username"
                    placeholder="Username"
                    value={formData.username}
                    onChange={handleChange}
                    className="bg-light border-0"
                    required
                  />
                </FloatingLabel>

                {/* Password Input */}
                <FloatingLabel controlId="floatingPassword" label="Password" className="mb-4">
                  <Form.Control
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    className="bg-light border-0"
                    required
                  />
                </FloatingLabel>

                <Button
                  type="submit"
                  className="w-100 py-3 border-0 mt-2"
                  style={{
                    backgroundColor: brandNavy,
                    borderRadius: "12px",
                    fontWeight: "600",
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <Spinner size="sm" className="me-2" animation="border" />
                      Verifying...
                    </>
                  ) : (
                    "Sign In Securely"
                  )}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </motion.div>
      </Container>

      {/* OTP Modal Container */}
      <Suspense fallback={<Loader />}>
        {modalOpen && (
          <OtpModal
            isOpen={modalOpen}
            toggle={toggleModal}
            onSubmit={handleOtpSubmit}
          />
        )}
      </Suspense>
    </div>
  );
};

export default Login;